(function () {
  'use strict';
  var configNode = document.getElementById('ErredueCommerceConfig');
  var config = {};
  try { config = JSON.parse(configNode ? configNode.textContent : '{}'); } catch (ignore) {}
  var root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || config.root || '/').replace(/\/?$/, '/');
  var searchUrl = config.searchUrl || root + 'search';

  function money(cents, currency) {
    try { return new Intl.NumberFormat(config.locale || 'it', {style: 'currency', currency: currency || config.currency || 'EUR'}).format(cents / 100); }
    catch (ignore) { return (cents / 100).toFixed(2) + ' ' + (currency || 'EUR'); }
  }
  function shippingGoal(total, currency, country) {
    var threshold = Number(config.shippingThreshold);
    var eligible = Boolean(config.shippingEnabled && threshold > 0 && currency === config.shippingCurrency && country === config.shippingCountry);
    var target = threshold + (config.shippingStrict ? 1 : 0);
    return {eligible: eligible, target: target, missing: Math.max(0, target - Number(total || 0)), value: Math.min(target, Math.max(0, Number(total || 0)))};
  }
  function safeUrl(value, image) {
    try {
      var parsed = new URL(value, window.location.origin);
      if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return '';
      if (!image && parsed.origin !== window.location.origin) return '';
      return parsed.href;
    } catch (ignore) { return ''; }
  }
  window.ErredueCommerce = {money: money, shippingGoal: shippingGoal, safeUrl: safeUrl};

  function updateShipping(cart) {
    var currency = (cart && cart.currency) || config.currency;
    var total = cart ? cart.total_price : null;
    if (total === null) return;
    var goal = shippingGoal(total, currency, config.country);
    document.querySelectorAll('[data-er-shipping-goal]').forEach(function (node) {
      node.hidden = !goal.eligible;
      if (!goal.eligible) return;
      var text = node.querySelector('[data-er-shipping-message]');
      var progress = node.querySelector('[data-er-shipping-progress]');
      text.textContent = goal.missing > 0
        ? 'Ti mancano ' + money(goal.missing, currency) + ' alla soglia per la spedizione gratuita in Italia.'
        : 'Soglia per la spedizione gratuita in Italia raggiunta.';
      progress.max = goal.target;
      progress.value = goal.value;
    });
  }

  function initSearch(scope) {
    scope.querySelectorAll('[data-er-search]').forEach(function (form) {
      if (form.dataset.erReady) return;
      form.dataset.erReady = 'true';
      var input = form.querySelector('[data-er-predictive-input]');
      var results = form.querySelector('[data-er-predictive-results]');
      var status = form.querySelector('[data-er-search-status]');
      var timer, controller, requestId = 0, activeIndex = -1;

      function close() {
        results.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        activeIndex = -1;
      }
      function options() { return results.querySelectorAll('[role="option"]'); }
      function activate(index) {
        var links = options();
        if (!links.length) return;
        activeIndex = (index + links.length) % links.length;
        links.forEach(function (link, i) {
          link.classList.toggle('is-active', i === activeIndex);
          link.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false');
        });
        input.setAttribute('aria-activedescendant', links[activeIndex].id);
        links[activeIndex].scrollIntoView({block:'nearest'});
      }
      function resultLink(url, label) {
        var link = document.createElement('a');
        link.href = url;
        link.id = results.id + '-' + results.children.length;
        link.setAttribute('role', 'option');
        link.setAttribute('aria-selected', 'false');
        link.tabIndex = -1;
        if (label) link.textContent = label;
        return link;
      }
      function show(products, query) {
        results.replaceChildren();
        activeIndex = -1;
        products.forEach(function (product) {
          if (window.ErredueCatalog && !window.ErredueCatalog.isVisible(product)) return;
          var url = safeUrl(product.url, false);
          if (!url) return;
          var link = resultLink(url);
          link.className = 'er-predictive-search__item';
          var imageValue = (product.featured_image || {}).url || product.image;
          if (imageValue && typeof imageValue === 'object') imageValue = imageValue.url;
          var imageUrl = imageValue ? safeUrl(imageValue, true) : '';
          if (imageUrl) {
            var img = document.createElement('img');
            img.src = imageUrl + (imageUrl.indexOf('?') === -1 ? '?' : '&') + 'width=120';
            img.alt = '';
            img.width = 48;
            img.height = 58;
            img.loading = 'lazy';
            link.appendChild(img);
          } else { link.appendChild(document.createElement('span')); }
          var info = document.createElement('span');
          var title = document.createElement('strong');
          title.textContent = product.title || '';
          var vendor = document.createElement('span');
          vendor.textContent = product.vendor || '';
          info.append(title, vendor);
          if (product.price !== null && product.price !== undefined && Number.isFinite(Number(product.price))) {
            var price = document.createElement('span');
            price.className = 'er-predictive-search__price';
            price.textContent = money(Math.round(Number(product.price) * 100));
            info.appendChild(price);
          }
          link.appendChild(info);
          results.appendChild(link);
        });
        var count = results.children.length;
        var all = resultLink(searchUrl + '?type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=hide&q=' + encodeURIComponent(query), count ? 'Vedi tutti i risultati →' : 'Cerca “' + query + '” nel catalogo →');
        all.className = 'er-predictive-search__all';
        results.appendChild(all);
        status.textContent = count ? count + ' prodotti suggeriti. Usa le frecce per scegliere oppure Invio per cercare.' : 'Nessun suggerimento. Premi Invio per cercare nel catalogo.';
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
      input.addEventListener('input', function () {
        window.clearTimeout(timer);
        if (controller) controller.abort();
        requestId += 1;
        close();
        var query = input.value.trim();
        if (query.length < 2 || !window.fetch) { status.textContent = ''; return; }
        var currentRequest = requestId;
        timer = window.setTimeout(function () {
          controller = window.AbortController ? new AbortController() : null;
          status.textContent = 'Ricerca in corso…';
          var url = root + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide';
          fetch(url, controller ? {signal:controller.signal} : {})
            .then(function (response) { if (!response.ok) throw new Error('Search unavailable'); return response.json(); })
            .then(function (data) {
              if (currentRequest !== requestId || input.value.trim() !== query || document.activeElement !== input) return;
              show((((data || {}).resources || {}).results || {}).products || [], query);
            })
            .catch(function (error) {
              if (error.name === 'AbortError' || currentRequest !== requestId) return;
              close();
              status.textContent = 'Premi Invio per cercare nel catalogo.';
            });
        }, 220);
      });
      input.addEventListener('keydown', function (event) {
        if (results.hidden) return;
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          activate(event.key === 'ArrowDown' ? activeIndex + 1 : (activeIndex < 0 ? options().length - 1 : activeIndex - 1));
        } else if (event.key === 'Enter' && activeIndex >= 0) {
          event.preventDefault();
          options()[activeIndex].click();
        } else if (event.key === 'Escape') { close(); event.stopPropagation(); }
        else if (event.key === 'Tab') close();
      });
      form.addEventListener('focusout', function (event) { if (!form.contains(event.relatedTarget)) close(); });
      document.addEventListener('click', function (event) { if (!form.contains(event.target)) close(); });
      form.addEventListener('submit', close);
    });
  }

  function initMenus() {
    var menu = document.getElementById('velaMenuMobile');
    var menuButton = document.getElementById('btnMenuMobile');
    var drawer = document.getElementById('cartDrawer');
    var lastMenuOpen = false, lastDrawerOpen = false, drawerSource;
    function sync() {
      var menuOpen = document.body.classList.contains('menuMobileActive');
      var drawerOpen = document.body.classList.contains('jsDrawerOpenRight');
      if (menu) {
        menu.setAttribute('aria-hidden', menuOpen ? 'false' : 'true');
        menu.toggleAttribute('inert', !menuOpen);
        if (menuButton) menuButton.setAttribute('aria-expanded', menuOpen ? 'true' : 'false');
        if (menuOpen && !lastMenuOpen) { menu.querySelector('.btnMenuClose').focus(); }
        if (!menuOpen && lastMenuOpen && menuButton) menuButton.focus();
      }
      if (drawer) {
        drawer.setAttribute('aria-hidden', drawerOpen ? 'false' : 'true');
        drawer.toggleAttribute('inert', !drawerOpen);
        if (drawerOpen && !lastDrawerOpen) { drawerSource = document.activeElement; var closeButton = drawer.querySelector('.jsDrawerClose'); if (closeButton) closeButton.focus(); }
        if (!drawerOpen && lastDrawerOpen && drawerSource && drawerSource.isConnected) drawerSource.focus();
      }
      document.querySelectorAll('.er-header__actions .jsDrawerOpenRight').forEach(function (link) { link.setAttribute('aria-expanded', drawerOpen ? 'true' : 'false'); });
      lastMenuOpen = menuOpen;
      lastDrawerOpen = drawerOpen;
    }
    if (window.MutationObserver) new MutationObserver(sync).observe(document.body, {attributes:true, attributeFilter:['class']});
    sync();
    document.addEventListener('keydown', function (event) {
      var open = document.body.classList.contains('menuMobileActive') ? menu : (document.body.classList.contains('jsDrawerOpenRight') ? drawer : null);
      if (!open) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        if (open === menu) document.body.classList.remove('menuMobileActive');
        else if (window.vela && vela.RightDrawer) vela.RightDrawer.close();
        sync();
      }
      if (event.key === 'Tab') {
        var focusables = Array.from(open.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),textarea,select,summary')).filter(function (el) { return el.getClientRects().length > 0; });
        if (!focusables.length) return;
        var first = focusables[0], last = focusables[focusables.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === open)) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || document.activeElement === open)) { event.preventDefault(); first.focus(); }
      }
    });
    document.querySelectorAll('[data-er-nav-toggle]').forEach(function (button) {
      var parent = button.closest('.er-nav__dropdown');
      function set(open) { parent.classList.toggle('is-open', open); button.setAttribute('aria-expanded', String(open)); }
      button.addEventListener('click', function () { set(button.hasAttribute('data-er-nav-brand') || button.getAttribute('aria-expanded') !== 'true'); });
      parent.addEventListener('mouseenter', function () { set(true); });
      parent.addEventListener('mouseleave', function () { if (!parent.contains(document.activeElement)) set(false); });
      parent.addEventListener('focusin', function (event) { if (event.target !== button) set(true); });
      parent.addEventListener('focusout', function (event) { if (!parent.contains(event.relatedTarget)) set(false); });
      parent.addEventListener('keydown', function (event) { if (event.key === 'Escape') { button.focus(); set(false); event.stopPropagation(); } });
      document.addEventListener('click', function (event) { if (!parent.contains(event.target)) set(false); });
    });
  }

  function initStickyBuy() {
    var bar = document.querySelector('[data-er-sticky-buy]');
    var main = document.getElementById('AddToCart');
    var price = document.getElementById('ProductPrice');
    if (!bar || !main || !price) return;
    var button = bar.querySelector('[data-er-sticky-add]');
    var mainVisible = true;
    function sync() {
      bar.querySelector('[data-er-sticky-price]').textContent = price.textContent;
      var adding = main.getAttribute('aria-busy') === 'true';
      button.disabled = main.disabled || adding;
      button.textContent = adding ? 'Aggiunta in corso…' : (main.disabled ? (document.getElementById('AddToCartText').textContent || 'Esaurito') : 'Aggiungi al carrello');
      var mobile = window.matchMedia('(max-width:767px)').matches;
      bar.hidden = !mobile || mainVisible;
      document.body.classList.toggle('er-has-sticky-buy', !bar.hidden);
    }
    button.addEventListener('click', function () {
      if (main.disabled) return;
      var form = main.form;
      if (!form.checkValidity()) { form.reportValidity(); main.scrollIntoView({block:'center',behavior:'smooth'}); return; }
      main.click();
    });
    document.addEventListener('erredue:variant-change', function (event) {
      var variant = event.detail.variant;
      price.classList.toggle('priceSale', Boolean(variant && variant.compare_at_price > variant.price));
      var quantity = document.getElementById('Quantity');
      if (variant && quantity && variant.quantity_rule) {
        quantity.min = variant.quantity_rule.min || 1;
        quantity.step = variant.quantity_rule.increment || 1;
        if (variant.quantity_rule.max) quantity.max = variant.quantity_rule.max;
        else quantity.removeAttribute('max');
        if (Number(quantity.value) < Number(quantity.min)) quantity.value = quantity.min;
      }
      sync();
    });
    if (window.IntersectionObserver) new IntersectionObserver(function (entries) { mainVisible = entries[0].isIntersecting; sync(); }, {threshold:0.2}).observe(main);
    if (window.MutationObserver) new MutationObserver(sync).observe(main, {attributes:true, attributeFilter:['disabled','aria-busy']});
    window.addEventListener('resize', sync, {passive:true});
    sync();
  }

  function init() {
    document.documentElement.classList.remove('no-js');
    initSearch(document);
    initMenus();
    initStickyBuy();
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-er-filter-toggle]');
      if (!toggle) return;
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;
      panel.hidden = !panel.hidden;
      toggle.setAttribute('aria-expanded', String(!panel.hidden));
      if (!panel.hidden) { var first = panel.querySelector('summary, input'); if (first) first.focus(); }
    });
    document.addEventListener('change', function (event) {
      if (event.target.matches('[data-er-cart-quantity]')) {
        var note = document.querySelector('[data-er-cart-update-note]');
        if (note) note.textContent = 'Quantità modificata. Premi Aggiorna carrello per ricalcolare il totale.';
        return;
      }
      if (!event.target.matches('[data-er-sort]')) return;
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.delete('page');
      window.location.assign(url.href);
    });
    if (window.jQuery) jQuery(document.body).on('ajaxCart.afterCartLoad.erredue', function (event, cart) { updateShipping(cart); });
    document.addEventListener('shopify:section:load', function (event) { initSearch(event.target); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
